export const chemicalExamSamplingOtherList = [
  { id: 1, name: "Ásványolaj termékek és kőolajipar technológiai minták" },
  { id: 2, name: "Növényi anyagok" },
];
